/*************************************************/
/* COOKIES                                       */
/*************************************************/

export function cookies() {
    const placeholderSelectors = Array.from(document.querySelectorAll('.cookie-placeholder'));

    //Implement this for the specific cookie solution
    const RenewConsent = category => {
        alert("Implement functionality in 'cookies.js'");
    }

    //Implement this for the specific cookie solution
    const SetPlaceholderState = () => {
        //Add event listeners for the consent being given
        //Go trough all the placeholders, compare the data-category to the set consent
            //If there is a match, remove the placeholder, else, dont.
    }

    const init = () => {

        SetPlaceholderState();

        for(const placeholderSelector of placeholderSelectors) {
            placeholderSelector.addEventListener('click', event => {
                event.stopPropagation()
                var category = placeholder.dataset.category;
                RenewConsent(category);
            });
        }
    };

    init();
}

